import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-estado-factura",
    templateUrl: "./dialog-estado-factura.component.html",
    styleUrls: ["./dialog-estado-factura.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogEstadoFacturaComponent implements OnInit {
    formFacturaPago: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogEstadoFacturaComponent>,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formFacturaPago = this.fb.group({
            fechaPago: [{ validators: [Validators.required] }],
        });
    }

    get fechaPago() {
        return this.formFacturaPago.get("fechaPago");
    }
}
